import React, {useCallback, useEffect} from "react";
import AppBar from "@mui/material/AppBar";
import {useTranslation} from "react-i18next";
import {connect} from "react-redux";
import HeaderDefault from "./HeaderDefault";
import HeaderVariantDrawer from "./HeaderVariantDrawer";
import HeaderVariantInline from "./HeaderVariantInline";

const headersMap = {
  default: HeaderDefault,
  inline: HeaderVariantInline,
  drawer: HeaderVariantDrawer
};

const mapStateToProps = state => ({
  baseURL: state.config.baseURL,
  isA11y: state.app.isA11y,
  defaultLanguage: state.app.language,
  languages: state.app.languages,
  moduleConfigs: state.moduleConfigs,
  themeConfig: state.themeConfig,
  hub: state.hub.hub,
  nodes: state.hub.nodes,
  node: state.node,
  catalog: state.catalog,
  user: state.user,
  filteredCatalog: state.detailLevel.filteredCatalog
});

const Header = ({
  baseURL,
  isA11y,
  defaultLanguage,
  languages,
  moduleConfigs,
  themeConfig,
  hub,
  nodes,
  node,
  title = node?.name,
  noNode = !node?.nodeId,
  catalog,
  user,
  filteredCatalog,
  isDefault,
  selectedCategoryPath,
  selectedDataset,
  ...props
}) => {
  const {t} = useTranslation();

  const SelectedHeader = headersMap[themeConfig.header] || HeaderDefault;

  const handleHeaderHeight = useCallback(() => {
    const nodeHeaderHeight = document.getElementById("header") ? document.getElementById("header").offsetHeight : 0;
    if (document.getElementById("main")) {
      document.getElementById("main").setAttribute("style", `padding-top: ${nodeHeaderHeight}px`);
    }
  }, []);

  useEffect(() => {
    window.addEventListener("resize", handleHeaderHeight);
    return () => {
      window.removeEventListener("resize", handleHeaderHeight);
    };
  }, [handleHeaderHeight]);

  useEffect(() => {
    handleHeaderHeight();
  });

  const isDefaultAndUniqueNode =
    !noNode && isDefault && node
      ? nodes.filter(n => n.code.toLowerCase() !== node.code.toLowerCase()).length === 0
      : false;

  return (
    <AppBar
      id="header"
      position="static"
      color="primary"
      role="banner"
      aria-label={t("components.header.appBar.ariaLabel")}
      sx={{
        position: "fixed",
        width: "100%",
        zIndex: theme => theme.zIndex.appBar
      }}
    >
      <SelectedHeader
        baseURL={baseURL}
        isA11y={isA11y}
        defaultLanguage={defaultLanguage}
        languages={languages}
        moduleConfigs={moduleConfigs}
        hub={hub}
        nodes={nodes}
        node={node}
        title={title}
        noNode={noNode}
        catalog={catalog}
        user={user}
        filteredCatalog={filteredCatalog}
        isDefaultAndUniqueNode={isDefaultAndUniqueNode}
        selectedCategoryPath={selectedCategoryPath}
        selectedDataset={selectedDataset}
        onRender={handleHeaderHeight}
        {...props}
      />
    </AppBar>
  );
};

export default connect(mapStateToProps)(Header);
